import { render, staticRenderFns } from "./TaskDefinitionsEdit.vue?vue&type=template&id=0fc1df83&scoped=true"
import script from "./TaskDefinitionsEdit.vue?vue&type=script&lang=js"
export * from "./TaskDefinitionsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc1df83",
  null
  
)

export default component.exports